<script>
    let scrollPosition = 0;
</script>
<svelte:window bind:scrollY={scrollPosition} />
{#if scrollPosition < 100}
    <div class="mouse_scroll">
        <!-- <div class="mouse">
            <div class="wheel"></div>
        </div> -->
        <div class="arrows">
            <span class="m_scroll_arrows unu"></span>
            <span class="m_scroll_arrows doi"></span>
            <span class="m_scroll_arrows trei"></span>
            <span class="m_scroll_arrows unu"></span>
            <span class="m_scroll_arrows doi"></span>
            <span class="m_scroll_arrows trei"></span>
        </div>
    </div>
{/if}

<style>
    .arrows {
        transform: rotate(180deg);
    }
</style>